<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.5 8.33h5a2.5 2.5 0 0 1 0 5H10V15h2.5a4.17 4.17 0 0 0 0-8.33h-5v-2.5L3.33 7.5l4.17 3.33v-2.5Z"
    fill="#565B61"
  />
</svg>
